import { useContext } from 'react';
import { ScopeContext } from '../Context.js';
import { useFieldState } from './useFieldState.js';

/* ----------------------- useScope ----------------------- */
function useScopedState() {
  var scope = useContext(ScopeContext);
  return useFieldState(scope);
}

export { useScopedState };
